module.exports = __webpack_public_path__ + "img/logo.f394e1ff.svg";